import { render, staticRenderFns } from "./ModelCanvas.vue?vue&type=template&id=3c5808ac&scoped=true&"
import script from "./ModelCanvas.vue?vue&type=script&lang=js&"
export * from "./ModelCanvas.vue?vue&type=script&lang=js&"
import style0 from "./ModelCanvas.vue?vue&type=style&index=0&id=3c5808ac&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5808ac",
  null
  
)

export default component.exports